import { render, staticRenderFns } from "./CourseVideo.vue?vue&type=template&id=6f8a5c1e&scoped=true&"
import script from "./CourseVideo.vue?vue&type=script&lang=js&"
export * from "./CourseVideo.vue?vue&type=script&lang=js&"
import style0 from "./CourseVideo.vue?vue&type=style&index=0&id=6f8a5c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a5c1e",
  null
  
)

export default component.exports